import { bootstrapApplication } from '@angular/platform-browser';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideZoneChangeDetection } from '@angular/core';
import { AppModule } from './app';
import { APP_BASE_HREF } from '@angular/common';
import { RX_APP_CONTEXT, RxAppContext } from '@nrwl/rx-root-state';
import { AUTH_SESSION_CLEANUP } from '@nrwl/rx-service-auth';
import { resolveLegacyV2PatientRecordRedirectUrl } from './app/core/utils/legacy-v2-link-redirect';
import { RxIntercomService } from './app/core/intercom/services/rx-intercom.service';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(AppModule),
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: APP_BASE_HREF, useValue: '/v19/' },
    { provide: RX_APP_CONTEXT, useValue: RxAppContext.RxPhoto },
    {
      provide: AUTH_SESSION_CLEANUP,
      multi: true,
      useFactory:
        (intercomService: RxIntercomService): (() => void) =>
        (): void =>
          intercomService.shutdown(),
      deps: [RxIntercomService],
    },
  ],
};

const legacyV2PatientRecordRedirectUrl = resolveLegacyV2PatientRecordRedirectUrl({
  baseHref: '/v19/',
  hash: window.location.hash,
  origin: window.location.origin,
});

if (legacyV2PatientRecordRedirectUrl && legacyV2PatientRecordRedirectUrl !== window.location.href) {
  window.location.replace(legacyV2PatientRecordRedirectUrl);
} else {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
}
